import React from "react";

import { useIsArcade } from "@/hooks/useIsArcade";

import type { UI_CONTEXT } from "../../analytics/constants";
import { CategoryProps } from "../../interfaces/category-interface";
import { Locale } from "../../types/locale";
import { BreadCrumbs } from "../breadcrumbs/breadcrumbs";
import { PAGE_TYPES } from "../breadcrumbs/breadcrumbs.constants";
import { ControlFilters } from "../control-filters/control-filters";
import { DropdownMenuItem } from "../dropdown-menus/dropdown-menu-items/dropdown-menu-item-interface";
import styles from "./controlHeader.module.scss";

export interface Props {
    locale: Locale;
    parentCategory: CategoryProps;
    currentCategory: CategoryProps;
    uiContext: UI_CONTEXT;
    hasOffers: boolean;
    hasInStore: boolean;
    handleOffersClick: () => void;
    handleInStoreClick: () => void;
    handleSortByClick: (sortByValue: string) => void;
    sortByOptions: Array<DropdownMenuItem>;
    inStoreLocationUrl: string;
}

export const ControlHeader: React.FC<Props> = ({
    currentCategory,
    locale,
    parentCategory,
    hasOffers,
    hasInStore,
    handleOffersClick,
    handleInStoreClick,
    handleSortByClick,
    sortByOptions,
    inStoreLocationUrl,
    uiContext,
}) => {
    const isArcade = useIsArcade();
    return (
        <div className={styles.controlHeaderContainer}>
            <>
                <BreadCrumbs
                    parentLink={parentCategory}
                    currentLink={currentCategory}
                    pageType={PAGE_TYPES.CATEGORY}
                />
                {isArcade ? (
                    <h5 className={styles.controlHeaderCategoryName}>{currentCategory.name}</h5>
                ) : (
                    <h2 className={styles.controlHeaderCategoryName}>{currentCategory.name}</h2>
                )}
            </>
            <ControlFilters
                currentCategory={currentCategory}
                locale={locale}
                hasOffers={hasOffers}
                hasInStore={hasInStore}
                handleOfferClick={handleOffersClick}
                handleInStoreClick={handleInStoreClick}
                handleSortByClick={handleSortByClick}
                sortByOptions={sortByOptions}
                inStoreLocationUrl={inStoreLocationUrl}
                uiContext={uiContext}
            />
        </div>
    );
};
